var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 15,
    height: 11.9997,
    viewBox: "0 0 15 11.9997",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M7.5 0C9.46368 0 11.1297 1.2598 11.7441 3.01367C11.8286 3.00653 11.9137 3 12 3C13.6569 3 15 4.34315 15 6C15 7.34085 14.12 8.47506 12.9062 8.85938C12.8537 8.86572 12.8015 8.87544 12.75 8.88867V7.04785C12.749 6.42817 12.2777 5.91625 11.6729 5.85449L11.5498 5.84863C10.9484 5.84875 10.4522 6.29176 10.3643 6.86719L9.09766 5.60059H9.09668C8.90004 5.40434 8.64201 5.28214 8.36719 5.25488L8.24902 5.24902C7.93074 5.24913 7.62493 5.37639 7.40039 5.60059L5.90039 7.10156C5.43318 7.56968 5.43172 8.32994 5.90039 8.79883L5.99219 8.88184C6.04881 8.92791 6.10971 8.96596 6.17188 9H2.25C1.00736 9 0 7.99264 0 6.75C0 5.50736 1.00736 4.5 2.25 4.5C2.5144 4.5 2.76727 4.54806 3.00293 4.63184C3.00167 4.58803 3 4.54411 3 4.5C3 2.01472 5.01472 0 7.5 0Z",
    fill: "#0F4AA2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 29",
    d: "M8.25 10.9497L8.25 6.44971M9.75 7.94971L8.25 6.44971L6.75 7.94971",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#0F4AA2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 28",
    d: "M11.5496 7.04972L11.5496 11.5497M13.0496 10.0497L11.5496 11.5497L10.0496 10.0497",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#0F4AA2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudStorage);
export default __webpack_public_path__ + "static/media/cloud-storage.e27b514f5347cfa4fb39979ebb2a0574.svg";
export { ForwardRef as ReactComponent };